import { combineReducers } from 'redux';
import accounts from 'data/accounts/accounts.reducer';
import licenses from 'data/licenses/licenses.reducer';
import login from 'data/login/login.reducer';
import messages from 'data/messages/messages.reducer';
import suppliers from 'data/suppliers/suppliers.reducer';
import federalBasicPermits from 'data/federalBasicPermits/federalBasicPermits.reducer';

const rootReducer = combineReducers({
  accounts,
  licenses,
  login,
  messages,
  suppliers,
  federalBasicPermits
});

export default rootReducer;
